<template>
  <div class="account-page">
    <!-- Main Wrapper -->
    <div class="main-wrapper">
      <div class="account-content">
        <div class="login-wrapper">

          <div class="login-img">
            <img src="../../../assets/img/login.png" alt="img" size="10" />
          </div>
          <div class="login-content">
            <div class="login-userset">
              <div class="login-logo logo-normal">
                <img src="../../../assets/img/logo.png" alt="img" />
              </div>
              <router-link to="/index" class="login-logo logo-white">
                <img src="../../../assets/img/logo-white.png" alt="" />
              </router-link>
              <div class="login-userheading">
                <h3>Confirm OTP</h3>
                <div class="d-flex justify-content-between">
                  <div>
                    <h4>Please enter the OTP</h4>
                  </div>

                  <div>
                    Didn't get the OTP?
                    <a @click="sendOtp()" class="hover-a">send again</a>
                  </div>
                </div>

              </div>
              <Form class="login" @submit="onSubmit" :validation-schema="schema" v-slot="{ errors }">
                <div class="form-login">
                  <label>OTP</label>
                  <div class="form-addons">
                    <Field name="phone" type="text" v-model="phone" class="form-control" aria-placeholder=""
                      :class="{ 'is-invalid': errors.phone }" :maxlength="6" />

                    <div class="invalid-feedback">{{ errors.phone }}</div>
                    <div class="emailshow text-danger" id="email"></div>
                    <!-- <img src="../../../assets/img/icons/mail.svg" alt="img" v-if="!(errors.email)" /> -->
                    <div class="position-absolute me-2 end-0 top-0 h-100 d-flex align-items-center"
                      v-if="!(errors.phone)">
                      <i class='bx bx-phone text-secondary' alt="img"></i>
                    </div>

                  </div>
                </div>
                <!-- <div class="form-login">
                  <label>Password</label>
                  <div class="pass-group">
                    <Field v-if="showPassword" name="password" type="text" value="123456" class="form-control pass-input"
                      :class="{ 'is-invalid': errors.password }" />
                    <Field v-else name="password" type="password" value="123456" class="form-control pass-input"
                      :class="{ 'is-invalid': errors.password }" />
                    <span @click="toggleShow" class="fas toggle-password" :class="{
                      'fa-eye': showPassword,
                      'fa-eye-slash': !showPassword,
                    }"></span>
                    <div class="invalid-feedback">{{ errors.password }}</div>
                    <div class="emailshow text-danger" id="password"></div>
                  </div>
                </div> -->
                <!-- <div class="form-login">
                  <div class="alreadyuser">
                    <h4>
                      <router-link to="forgetpassword" class="hover-a">Forgot Password?</router-link>
                    </h4>
                  </div>
                </div> -->
                <div class="form-login">
                  <button type="submit" class="btn btn-login">Confirm</button>
                  <!-- <router-link class="btn btn-login" to="pin"></router-link> -->
                </div>
              </Form>
              <div class="signinform text-center d-flex justify-content-start">
                <div>
                  <router-link to="/" class="hover-a">Change account</router-link>
                </div>
              </div>
              <!-- <div class="form-setlogin">
                <h4>Or sign up with</h4>
              </div> -->
              <!-- <div class="form-sociallink">
                <ul>
                  <li>
                    <a href="javascript:void(0);">
                      <img src="../../../assets/img/icons/google.png" class="me-2" alt="google" />
                      Sign Up using Google
                    </a>
                  </li>
                  <li>
                    <a href="javascript:void(0);">
                      <img src="../../../assets/img/icons/facebook.png" class="me-2" alt="google" />
                      Sign Up using Facebook
                    </a>
                  </li>
                </ul>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Main Wrapper -->
</template>
<script>
import { Form, Field } from "vee-validate";
import * as Yup from "yup";
import axios from "axios";
import Cookies from "js-cookie";
import { AlertPopup2, base_url, timeout, ErrorConnectionTimeOut, goPage } from "@/assets/js/function";

export default {
  components: {
    Form,
    Field,
  },
  data() {
    return {
      showPassword: false,
      password: null,
      phone: "",
      timer: 0,
    };
  },
  computed: {
    buttonLabel() {
      return this.showPassword ? "Hide" : "Show";
    },
  },
  created() {
    const now = new Date();
    now.setSeconds(now.getSeconds() + 0);
    const timeNow = now.getTime();
    localStorage.setItem("SendOTPDate", timeNow);
    localStorage.setItem('isSendOTP', 'false');
    if (!Cookies.get('token_refresh')) {
      goPage('/');
    }
  },
  methods: {
    toggleShow() {
      this.showPassword = !this.showPassword;
    },

    async cekIsSendOTP() {
      let date_now = new Date();
      date_now = date_now.setSeconds(date_now.getSeconds() + 0);
      const date_local = parseInt(localStorage.getItem('SendOTPDate'));

      if (date_local < date_now) {
        localStorage.setItem('isSendOTP', 'true');
      } else {
        this.timer = parseInt(((date_now - date_local) / 1000) * -1);
        localStorage.getItem('isSendOTP', 'false');
        AlertPopup2("error", "", "coba lagi dalam " + this.timer + " detik", true, 2000);
      }
    },

    async sendOtp() {
      await this.cekIsSendOTP();
      
      try {
        const phone = localStorage.getItem('phone');
        const formData = new FormData();
        formData.append("phone", phone);

        const api = base_url + 'v3/auth/forgot';
        const res = await axios.post(api, formData, { timeout });
        const data = res.data;

        if (data.status) {
          Cookies.set("token_refresh", data.data.token);
          goPage('confirm-otp');
          AlertPopup2("success", "", "OTP has been sent", false, 1500);
        } else {
          AlertPopup2("error", "", data.message, false, 2000);
        }

      } catch (error) {
        ErrorConnectionTimeOut(error);
      }
    }

  },
  setup() {
    const schema = Yup.object().shape({
      phone: Yup.string().required("OTP is required").min(6, "OTP must be at least 6 characters").max(6, "OTP just only 6 characters"),
    });
    const onSubmit = async (values) => {
      try {
        const formData = new FormData();
        formData.append("phone", localStorage.getItem('phone'));
        formData.append("otp", values.phone);
        formData.append("token", Cookies.get('token_refresh'));

        const api = base_url + 'v3/auth/verify';
        const res = await axios.post(api, formData, { timeout });
        const data = res.data;

        if (data.status) {
          Cookies.set("token_refresh", data.data.token);
          goPage('reset-pin');
        } else {
          AlertPopup2("error", "", data.message, true, 2000);
        }
      } catch (err) {
        ErrorConnectionTimeOut(err);
      }
    };
    return {
      schema,
      onSubmit,
    };
  },
};
</script>
